import { useState } from 'react';
import { useSurvey } from '../../context/SurveyContext';
import Logo from '../UI/Logo';
import WelcomeScreen from './WelcomeScreen';
import GoalsScreen from './GoalsScreen';
import HealthRatingScreen from './HealthRatingScreen';
import EducationScreen from './EducationScreen';
import TransitionScreen from './TransitionScreen';

export default function PreSurveyBoostersContainer({ onComplete }) {
  const { product } = useSurvey();
  const [currentScreen, setCurrentScreen] = useState(1);

  const handleContinue = () => {
    if (currentScreen < 5) {
      setCurrentScreen(currentScreen + 1);
      window.scrollTo(0, 0);
    } else {
      // All pre-survey boosters complete, start main survey
      onComplete();
    }
  };

  const screens = {
    1: <WelcomeScreen product={product} onContinue={handleContinue} />,
    2: <GoalsScreen onContinue={handleContinue} />,
    3: <HealthRatingScreen onContinue={handleContinue} />,
    4: <EducationScreen product={product} onContinue={handleContinue} />,
    5: <TransitionScreen onContinue={handleContinue} />
  };

  return (
    <div className="min-h-screen bg-warm-beige">
      <div className="container mx-auto px-4 py-8">
        <Logo className="mb-8" />
        {screens[currentScreen]}
      </div>
    </div>
  );
}
